import React, { useState } from 'react'
import { CircularProgress } from '@material-ui/core'
import { Box, TertiaryButton, Tooltip } from '@workday/canvas-kit-react'
import { Centered } from '../../components/Centered'
import AutoRefreshLine from './AutoRefreshLine'

export type AutoRefreshButtonProps = {
  refreshIntervalSeconds: number
  onRefresh: (completion: () => void) => void
}

const AutoRefreshButton = ({ onRefresh, refreshIntervalSeconds }: AutoRefreshButtonProps) => {
  const [loadingNewContent, setLoadingNewContent] = useState(false)
  const refreshFeed = () => {
    setLoadingNewContent(true)
    onRefresh(() => {
      setLoadingNewContent(false)
    })
  }

  return (
    <Tooltip title="Refresh Feed">
      <TertiaryButton width="60px" onClick={event => refreshFeed()} borderRadius="circle">
        {loadingNewContent ? (
          <Centered>
            <CircularProgress size={20} />
          </Centered>
        ) : (
          <Box width="40px">
            <AutoRefreshLine
              refreshIntervalSeconds={refreshIntervalSeconds}
              onRefresh={onRefresh}
            />
          </Box>
        )}
      </TertiaryButton>
    </Tooltip>
  )
}

export default AutoRefreshButton
